export default "__VITE_ASSET__m1a93foS__"